import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import CompactListItem from '../../../shared/CompactListItem';
import CompactItemInfo from '../../../shared/CompactItemInfo';

export default class InterlibraryLoanItem extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll(
      'renderItemSummary',
      'renderItemStatus',
      'renderPickUpAt',
      'renderPlacedOn',
      'renderPickUpBy'
    );
  }

  renderItemStatus() {
    // TODO CORE-48927 Build a status component
    const { item } = this.props;
    return (
      <div className="item-status" key="item-status">
        {item.get('status')}
      </div>
    );
  }

  renderItemSummary() {
    // TODO CORE-48926 Build a generic component for compact list item info
    const { item } = this.props;
    return (
      <div className="item-summary" key="item-summary">
        <CompactItemInfo
          title={item.get('title')}
          subtitle={item.get('subtitle')}
          author={item.get('author')}
          format={item.get('format')} />
      </div>
    );
  }

  renderPickUpAt() {
    // TODO CORE-48929 Build a generic compact info component
    const { item } = this.props;
    return (
      <div className="item-pick-up-at" key="item-pick-up-at">
        {item.has('pickupLocation') ? item.getIn(['pickupLocation', 'name']) : ''}
      </div>
    );
  }

  renderPickUpBy() {
    // TODO CORE-48929 Build a generic compact info component
    const { item } = this.props;
    return (
      <div className="item-pick-by" key="item-pick-up-by">
        {item.has('pickupByDate') ? item.get('pickupByDate') : ''}
      </div>
    );
  }

  renderPlacedOn() {
    // TODO CORE-48929 Build a generic compact info component
    const { item } = this.props;
    return (
      <div className="item-placed-on" key="item-placed-on">
        {item.get('holdPlacedDate')}
      </div>
    );
  }


  render() {
    return (
      <CompactListItem
        columns={[this.renderItemSummary(),
          this.renderItemStatus(),
          this.renderPickUpAt(),
          this.renderPickUpBy(),
          this.renderPlacedOn()]}
        className="cp-interlibraryloan-item" />
    );
  }
}

InterlibraryLoanItem.propTypes = {
  item: ImmutablePropTypes.map
};



// WEBPACK FOOTER //
// ./app/components/borrowing/interlibraryLoans/InterlibraryLoanItem/InterlibraryLoanItem.jsx